import script from "./DashboardNewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardNewPage.vue?vue&type=script&setup=true&lang=js"

import "./DashboardNewPage.vue?vue&type=style&index=0&id=df28fdec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-df28fdec"]])

export default __exports__